import Vue from 'vue'
import store from '@/store'
import VueRouter from 'vue-router'
import Home from '@/views/home.vue'
import Subscribe from '@/views/subscribe/index.vue'
import jx from '@/views/subscribe/details.vue'
import vd from '@/views/subscribe/videoDetails.vue'
import User from '@/views/userCenter/index.vue'
import Notice from '@/views/notice/index.vue'
import Collect from '@/views/collect/index.vue'
import Tab from '@/views/tab/index.vue'
import utils from '@/utils/index'
import { LoginSSOAPI, userInfoAPI } from '@/axios/common'
import conf from '@/utils/config/index'
import { eventBus } from '@/utils/event-bus'

Vue.use(VueRouter)
async function getUser() {
  try {
    let res = await userInfoAPI({
      version_type: 2,
    })
    store.commit('setAttr', {
      name: 'isapp',
      val: 1,
    })
    if (res.status == 1) {
      store.commit('setAttr', {
        name: 'userInfo',
        val: res.data,
      })
      store.commit('setAttr', {
        name: 'isLogin',
        val: 1,
      })
      localStorage.setItem('gfansLogin',1)
      store.commit('setAttr', {
        name: 'iamvip',
        val: res.data.iamvip,
      })
      store.commit('setAttr', {
        name: 'isDownloadStyles',
        val: res.data.isDownloadStyle,
      })
      eventBus.$emit('upHotList')
      eventBus.$emit('getMsg')
      eventBus.$emit('getCollect')
    }
  } catch (err) {
    store.commit('setAttr', {
      name: 'isapp',
      val: 1,
    })
  }
}
let isLogin = store.state.isLogin
const routes = [
  {
    path: '/discover',
    name: 'home',
    component: Home,
    meta: {
      title: 'Gfans - 订阅分享平台',
      requiresAuth: false,
      keepScroll: true,
    },
  },
  {
    path: '/subscribe',
    name: 'subscribe',
    component: Subscribe,
    meta: {
      title: 'Gfans',
      requiresAuth: true,
      keepScroll: true,
    },
  },
  {
    path: '/jx/:id',
    name: 'jx',
    component: jx,
    meta: {
      title: 'Gfans',
      requiresAuth: false,
    },
  },
  {
    path: '/vd/:id',
    name: 'vd',
    component: vd,
    meta: {
      title: 'Gfans',
      requiresAuth: false,
    },
  },
  {
    path: '/user/:uid',
    name: 'user',
    component: User,
    meta: {
      title: 'Gfans',
      requiresAuth: true,
      keepScroll: true,
    },
  },
  {
    path: '/notice',
    name: 'notice',
    component: Notice,
    meta: {
      title: 'Gfans',
      requiresAuth: true,
    },
  },
  {
    path: '/collect',
    name: 'collect',
    component: Collect,
    meta: {
      title: 'Gfans',
      requiresAuth: true,
    },
  },
  {
    path: '/tab/:id',
    name: 'tab',
    component: Tab,
    meta: {
      title: 'Gfans',
      requiresAuth: false,
    },
  },
  {
    path: '/',
    // redirect: '/',
    redirect: `${isLogin == 1 ? '/subscribe' : '/discover'}`,
    meta: {
      title: 'Gfans - 订阅分享平台',
      requiresAuth: false,
    },
  },
  {
    path: '*', // 通配符路径，匹配所有未定义的路由
    redirect: '/', // 重定向到根路径或其他默认页面
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // 核心：滚动行为控制
  scrollBehavior(to, from) {
    // 检查meta标记，需要保留滚动位置的页面
    if (
      to.matched.some(record => record.meta.keepScroll) &&
      from.name !== null
    ) {
      return false
    }
    // 4. 默认行为：滚动到顶部
    return { x: 0, y: 0 }
  },
})
// 在全局导航守卫中检查元字段-全局前置守卫
router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  const requiresAuth = to.meta.requiresAuth
  const isLoggedIn = store.state.isLogin == 1
  // 未登录但访问需要认证的页面
  if (requiresAuth && !isLoggedIn) {
    next({
      path: '/discover',
      replace: true,
    })
  }
  if (to.query.platfro) {
    store.commit('setAttr', {
      name: 'isapp',
      val: 0,
    })
    let isPage = to.name == 'home' ? 1 : 2
    store.commit('setAttr', {
      name: 'isPage',
      val: isPage,
    })
    let platfro = to.query.platfro
    localStorage.setItem('platfro', platfro)
    try {
      const res = await LoginSSOAPI({ token: platfro })
      if (res.status == 1) {
        localStorage.setItem('authtoken1', res.data.authtoken)
        next({
          path: to.path,
          query: {}, // 清空所有查询参数
          replace: true, // 替换当前路由记录
        })
        await getUser()
      }
    } catch (e) {
      next()
    }
    return
  }
  next() // 确保最终调用
})
// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}
export default router
